(function () {
  "use strict";
  let lenis = null;
  let lenisTicker = null;
  /* --------------------------------------------------------
     Stable viewport height (fixes iOS Safari jump bug)
  -------------------------------------------------------- */
  function getVH() {
    return window.visualViewport ? window.visualViewport.height : window.innerHeight;
  }

  /* --------------------------------------------------------
     All media loaded
  -------------------------------------------------------- */
  function allImagesLoaded(callback) {
    const media = document.querySelectorAll('img, video');
    let loadedCount = 0;
    const total = media.length;

    if (total === 0) { callback(); return; }

    const done = () => { if (++loadedCount === total) callback(); };

    media.forEach(el => {
      if (el.tagName === 'IMG') {
        if (el.complete) done();
        else {
          el.addEventListener('load', done, { once: true });
          el.addEventListener('error', done, { once: true });
        }
      }
      // else if (el.tagName === 'VIDEO') {
      //     if (el.readyState >= 2) done();
      //     else {
      //         el.addEventListener('loadeddata', done, { once: true });
      //         el.addEventListener('error',      done, { once: true });
      //     }
      // }
    });

    setTimeout(() => { if (loadedCount < total) callback(); }, 5000);
  }

  /* --------------------------------------------------------
     Single window load — init order matters
  -------------------------------------------------------- */
  $(window).on("load", function () {
    initLenis();
    requestAnimationFrame(() => {
      ScrollTrigger.refresh();
    });            // ← only here, NOT in doc.ready
    if (typeof ScrollTrigger === 'undefined') return;
    allImagesLoaded(() => {
      ScrollTrigger.sort();
      setTimeout(() => { ScrollTrigger.refresh(); }, 200);
    });
  });

  $(window).on("beforeunload", function () { window.scrollTo(0, 0); });

  /* --------------------------------------------------------
     Lenis
  -------------------------------------------------------- */


  function initLenis() {
    if (typeof Lenis === "undefined") { console.warn("Lenis not found."); return; }

    // Check if mobile device (viewport width less than 768px)
    const isMobileMenuHidden = $('.mobile-menu').hasClass('hidden')
    if (window.innerWidth <= 768 && !isMobileMenuHidden) {
      if (lenis) {
        if (typeof gsap !== "undefined" && lenisTicker) {
          gsap.ticker.remove(lenisTicker);
          lenisTicker = null;
        }
        lenis.destroy();
        lenis = null;
      }
      return;
    }

    if (lenis) return; // ← guard: never init twice

    const hasGSAP = typeof gsap !== "undefined";
    const hasScrollTrigger = hasGSAP && typeof ScrollTrigger !== "undefined";

    lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: "vertical",
      gestureOrientation: "vertical",
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
      infinite: false,
    });

    if (hasScrollTrigger) {
      lenis.on("scroll", ScrollTrigger.update);
      lenisTicker = (time) => {
        if (lenis) {
          lenis.raf(time * 1000);
        }
      };
      gsap.ticker.add(lenisTicker);
      gsap.ticker.lagSmoothing(0);

      // Tell ScrollTrigger to read Lenis's virtual scroll position instead of
      // querying the native DOM scrollTop — this is what eliminates the forced
      // reflow loop between Lenis's transform-based scroll and ScrollTrigger's
      // own geometry reads.
      ScrollTrigger.scrollerProxy(document.body, {
        scrollTop(value) {
          if (arguments.length) {
            lenis.scrollTo(value, { immediate: true });
          }
          return lenis.scroll;
        },
        getBoundingClientRect() {
          return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
        },
        pinType: document.body.style.transform ? 'transform' : 'fixed',
      });
    } else {
      (function rafLoop(time) {
        if (!lenis) return;
        lenis.raf(time);
        requestAnimationFrame(rafLoop);
      })(performance.now());
    }

    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        const href = this.getAttribute("href");
        if (href === "#") { e.preventDefault(); return; }
        try {
          const target = document.querySelector(href);
          if (!target) return;
          e.preventDefault();
          lenis.scrollTo(target, { offset: 0, duration: 1.4 });
        } catch (err) { }
      });
    });

    document.addEventListener("visibilitychange", () => {
      document.hidden ? lenis.stop() : lenis.start();
    });

    console.log("✓ Lenis initialised.");
  }

  /* --------------------------------------------------------
     Document Ready — NO initLenis() call here
  -------------------------------------------------------- */
  $(document).ready(function () {
    gsap.registerPlugin(ScrollTrigger);
    mobileMenuInit();
    initializeFaqAccordion();
    equalizeHeights();
    initStepsScrollAnim();
    initGuestPhoneAnim();
    initCustomizationTabs();
    initPillCycle();
    initVideoSequencer('.banner-left-video');
    initVideoSequencer('.banner-right-video');
    initVideoSequencer('.mobile-video-wrapper');
  });

  /* --------------------------------------------------------
     Video Sequencer — lazy src assignment + single active video
  -------------------------------------------------------- */
  // function initVideoSequencer(containerSelector) {
  //   document.querySelectorAll(containerSelector).forEach(function (container) {
  //     var videos = Array.from(container.querySelectorAll('.repeated-video'));
  //     if (!videos.length) return;
  //     videos.forEach(function (v) { v.style.display = 'none'; });
  //     videos[0].style.display = '';
  //     function playVideo(index) {
  //       var current = videos[index];
  //       current.currentTime = 0;
  //       function onEnded() {
  //         current.removeEventListener('ended', onEnded);
  //         current.style.display = 'none';
  //         var next = (index + 1) % videos.length;
  //         videos[next].style.display = '';
  //         playVideo(next);
  //       }
  //       var p = current.play();
  //       if (p !== undefined) {
  //         p.then(() => current.addEventListener('ended', onEnded))
  //           .catch(() => {
  //             document.addEventListener('click', function retry() {
  //               document.removeEventListener('click', retry);
  //               current.play().then(() => current.addEventListener('ended', onEnded));
  //             }, { once: true });
  //           });
  //       } else {
  //         current.addEventListener('ended', onEnded);
  //       }
  //     }
  //     playVideo(0);
  //   });
  // }

  function initVideoSequencer(containerSelector) {
    document.querySelectorAll(containerSelector).forEach(function (container) {
      var videos = Array.from(container.querySelectorAll('.repeated-video'));
      if (!videos.length) return;

      // Video[0] is the LCP candidate — it must already be visible and
      // fetching via its real `src` directly from HTML (set in Liquid),
      // so the browser can paint it without waiting for this script to run.
      // Only videos after the first are hidden + deferred.
      videos.forEach(function (v, i) {
        if (i === 0) return;
        v.style.display = 'none';
      });

      function activate(index) {
        var video = videos[index];

        // Assign real src only now — this is the moment the browser starts fetching
        if (!video.src && video.dataset.src) {
          video.src = video.dataset.src;
          video.preload = 'auto';
        }

        video.style.display = '';
        video.currentTime = 0;

        function onEnded() {
          video.removeEventListener('ended', onEnded);
          deactivate(index);
          var next = (index + 1) % videos.length;
          activate(next);
        }

        var playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise
            .then(function () { video.addEventListener('ended', onEnded); })
            .catch(function () {
              document.addEventListener('click', function retry() {
                document.removeEventListener('click', retry);
                video.play().then(function () { video.addEventListener('ended', onEnded); });
              }, { once: true });
            });
        } else {
          video.addEventListener('ended', onEnded);
        }
      }

      function deactivate(index) {
        var video = videos[index];
        video.pause();
        video.style.display = 'none';
        // Drop the src so the browser releases the buffered video from memory
        // once it's no longer the active one in the sequence.
        video.removeAttribute('src');
        video.load();
      }

      // Video[0] was already given a real `src` directly in HTML (not
      // data-src), so the browser is already fetching/painting it without
      // waiting on this observer. We just need to attach the "ended" handler
      // so the sequence continues to video[1] once it finishes.
      if (videos[0].src) {
        videos[0].addEventListener('ended', function onFirstEnded() {
          videos[0].removeEventListener('ended', onFirstEnded);
          deactivate(0);
          activate(1 % videos.length);
        });
        if (videos[0].paused) {
          var p = videos[0].play();
          if (p !== undefined) p.catch(function () { });
        }
      } else {
        // Fallback: if video[0] wasn't given an eager src for some reason,
        // behave exactly as before.
        videos[0].style.display = 'none';
        var started = false;
        var io = new IntersectionObserver(function (entries) {
          if (started || !entries[0].isIntersecting) return;
          started = true;
          io.disconnect();
          activate(0);
        }, { rootMargin: '200px 0px' });
        io.observe(container);
        return;
      }

      // Remaining videos (2nd onward) still wait for the container to be
      // near the viewport before fetching — this preserves the original
      // payload-reduction fix for everything except the LCP candidate.
      if (videos.length > 1) {
        var startedRest = false;
        var ioRest = new IntersectionObserver(function (entries) {
          if (startedRest || !entries[0].isIntersecting) return;
          startedRest = true;
          ioRest.disconnect();
          // no-op: activation of videos[1+] happens naturally via the
          // onEnded chain started above once video[0] finishes playing.
        }, { rootMargin: '200px 0px' });
        ioRest.observe(container);
      }
    });
  }

  /* --------------------------------------------------------
     Mobile Menu
  -------------------------------------------------------- */
  function mobileMenuInit() {
    $('.hamburger-icon').on('click', function (e) {
      e.preventDefault();
      $('.mobile-menu-open-btn').toggleClass('hidden');
      $('.mobile-menu-close-btn').toggleClass('hidden');
      $('.mobile-menu').toggleClass('hidden');
      $('header').toggleClass('header-fixed');
      // $('html, body').toggleClass('overflow-hidden');
      // if (lenis) {
      //   $('.mobile-menu').hasClass('hidden') ? lenis.start() : lenis.stop();
      // }
      initLenis();
    });
  }

  /* --------------------------------------------------------
     Sticky Header
  -------------------------------------------------------- */
  let lastScrollY = 0;
  $(window).on('scroll', function () {
    const scrollY = $(this).scrollTop();
    if (scrollY > 1000) {
      $('.header-main').addClass('header-sticky');
      if (scrollY < lastScrollY) {
        $('.header-main').removeClass('header-visible').addClass('header-hidden');
      } else {
        $('.header-main').removeClass('header-hidden').addClass('header-visible');
      }
    }
    if (scrollY < 100) {
      $('.header-main').removeClass('header-sticky header-visible header-hidden');
    }
    lastScrollY = scrollY;
  });

  /* --------------------------------------------------------
     FAQ Accordion
  -------------------------------------------------------- */
  function initializeFaqAccordion() {
    const $faqWrappers = $('.faq-wrapper');
    if (!$faqWrappers.length) return;
    $faqWrappers.each(function () {
      const $wrapper = $(this);
      const $faqs = $wrapper.find('.single-faq');
      $faqs.each(function (i) { $(this).toggleClass('active', i === 0); });
      $faqs.on('click', function () {
        const $this = $(this);
        const wasActive = $this.hasClass('active');
        $faqs.removeClass('active');
        if (!wasActive) $this.addClass('active');
        setTimeout(() => {
          if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
        }, 400);
      });
    });
  }

  /* --------------------------------------------------------
     How It Works — Steps Scroll Anim
  -------------------------------------------------------- */
  function initStepsScrollAnim() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    var section = document.querySelector('.how-it-works');
    if (!section) return;
    var steps = Array.from(section.querySelectorAll('.single-step-work'));
    var divider = section.querySelector('.how-it-works-devider');
    if (!steps.length) return;

    var triggers = [], timelines = [];

    // function buildAnim() {
    //   triggers.forEach(t => t.kill());
    //   timelines.forEach(tl => tl.kill());
    //   triggers = []; timelines = [];

    //   var isMobile = window.innerWidth < 769;
    //   gsap.set(steps, { clearProps: 'all' });
    //   if (divider) gsap.set(divider, { clearProps: 'all' });

    //   var tl = gsap.timeline({ paused: true });

    //   if (isMobile) {
    //     gsap.set(steps, { y: 40, x: 0, opacity: 0, force3D: true });
    //     if (divider) gsap.set(divider, { width: '1px', height: '0%' });
    //     steps.forEach(function (step, i) {
    //       tl.to(step, { y: 0, opacity: 1, duration: 1, ease: 'power2.out', force3D: true }, i * 1.5);
    //       if (divider) {
    //         tl.to(divider, { height: ((i + 1) / steps.length) * 110 + '%', duration: 1, ease: 'none' }, i * 1.5);
    //       }
    //     });
    //     triggers.push(ScrollTrigger.create({
    //       trigger: section, start: 'top 70%', end: '+=600',
    //       animation: tl, scrub: 1.5
    //     }));
    //   } else {
    //     gsap.set(steps, { x: -60, y: 0, opacity: 0, force3D: true });
    //     if (divider) gsap.set(divider, { width: '0%' });
    //     var desktopWidths = ['13%', '53%', '100%'];
    //     steps.forEach(function (step, i) {
    //       tl.to(step, { x: 0, opacity: 1, duration: 1, ease: 'power2.out', force3D: true }, i * 1.2);
    //       if (divider) {
    //         tl.to(divider, { width: desktopWidths[i] || '100%', duration: 1, ease: 'power1.inOut' }, i * 1.2);
    //       }
    //     });
    //     triggers.push(ScrollTrigger.create({
    //       trigger: section, start: 'top 20%',
    //       end: '+=' + (window.innerHeight * steps.length * 0.35),
    //       pin: true, pinSpacing: true, animation: tl, scrub: 1,
    //       onRefresh: self => self.animation.progress(self.progress)
    //     }));
    //   }
    //   timelines.push(tl);
    // }
    function buildAnim() {
      triggers.forEach(t => t.kill());
      timelines.forEach(tl => tl.kill());
      triggers = []; timelines = [];

      gsap.set(steps, { clearProps: 'all' });
      if (divider) gsap.set(divider, { clearProps: 'all' });

      // Let the clearProps writes flush before any geometry reads happen —
      // this breaks the read-after-write chain that was forcing synchronous
      // layout on every buildAnim() call (resize + initial load).
      requestAnimationFrame(function () {
        var isMobile = window.innerWidth < 769;
        var tl = gsap.timeline({ paused: true });

        if (isMobile) {
          gsap.set(steps, { y: 40, x: 0, opacity: 0, force3D: true });
          if (divider) gsap.set(divider, { width: '1px', height: '0%' });
          steps.forEach(function (step, i) {
            tl.to(step, { y: 0, opacity: 1, duration: 1, ease: 'power2.out', force3D: true }, i * 1.5);
            if (divider) {
              tl.to(divider, { height: ((i + 1) / steps.length) * 110 + '%', duration: 1, ease: 'none' }, i * 1.5);
            }
          });
          triggers.push(ScrollTrigger.create({
            trigger: section, start: 'top 70%', end: '+=600',
            animation: tl, scrub: 1.5
          }));
        } else {
          gsap.set(steps, { x: -60, y: 0, opacity: 0, force3D: true });
          if (divider) gsap.set(divider, { width: '0%' });
          var desktopWidths = ['13%', '53%', '100%'];
          steps.forEach(function (step, i) {
            tl.to(step, { x: 0, opacity: 1, duration: 1, ease: 'power2.out', force3D: true }, i * 1.2);
            if (divider) {
              tl.to(divider, { width: desktopWidths[i] || '100%', duration: 1, ease: 'power1.inOut' }, i * 1.2);
            }
          });
          triggers.push(ScrollTrigger.create({
            trigger: section, start: 'top 20%',
            end: '+=' + (window.innerHeight * steps.length * 0.35),
            pin: true, pinSpacing: true, animation: tl, scrub: 1,
            onRefresh: self => self.animation.progress(self.progress)
          }));
        }

        timelines.push(tl);
        ScrollTrigger.refresh();
      });
    }

    requestAnimationFrame(() => { buildAnim(); ScrollTrigger.refresh(); });

    var resizeTimer, lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        buildAnim();
        requestAnimationFrame(() => ScrollTrigger.refresh());
      }, 250);
    });
  }

  /* --------------------------------------------------------
     Guest Phone — Scroll Animations
  -------------------------------------------------------- */
  function initGuestPhoneAnim() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    var section = document.querySelector('.guest-journey .js-guest-journey-container');
    var phoneWrapper = document.querySelector('.guest-phone-wrapper');
    if (!section || !phoneWrapper) return;
    var phones = Array.from(phoneWrapper.querySelectorAll('.single-guest-phone'));
    if (!phones.length) return;

    var triggers = [], timelines = [];

    function buildAnim() {
      triggers.forEach(t => t.kill());
      timelines.forEach(tl => tl.kill());
      triggers = []; timelines = [];

      gsap.set(phones, { clearProps: 'all' });
      phones.forEach(s => s.classList.remove('gp-active'));

      if (window.innerWidth >= 1024) {
        // Desktop Anim
        gsap.set(phones, { y: 60, opacity: 0, force3D: true });

        var tl = gsap.timeline({ paused: true });
        phones.forEach(function (phone, i) {
          tl.to(phone, { y: 0, opacity: 1, duration: 1, ease: 'power2.out', force3D: true }, i);
        });
        tl.to({}, { duration: 0.5 });
        timelines.push(tl);

        triggers.push(ScrollTrigger.create({
          trigger: section,
          start: 'top -10%',
          end: '+=' + (getVH() * phones.length / 2),
          pin: true, pinSpacing: true, animation: tl, scrub: true,
          anticipatePin: 1,
          invalidateOnRefresh: true,
          onRefresh: self => self.animation.progress(self.progress)
        }));
      } else {
        // Mobile Anim
        // Use section as trigger so ScrollTrigger knows the correct entry point,
        // and pin only the phoneWrapper so the section itself anchors correctly.
        gsap.set(phones, { opacity: 0 });
        gsap.set(phones[0], { opacity: 1 });

        var tl = gsap.timeline({ paused: true });
        for (let i = 1; i < phones.length; i++) {
          tl.to({}, { duration: 1 }, i - 1);
          tl.to(phones[i - 1], { opacity: 0, duration: 0.05, ease: 'none' }, i);
          tl.to(phones[i], { opacity: 1, duration: 0.05, ease: 'none' }, i);
        }
        tl.to({}, { duration: 1 });
        timelines.push(tl);

        var totalPin = getVH() * phones.length * 1.2;

        triggers.push(ScrollTrigger.create({
          trigger: section,
          start: 'top -10%',
          end: '+=' + totalPin,
          pin: true,
          pinSpacing: true,
          animation: tl,
          scrub: true,
          anticipatePin: 1,
          invalidateOnRefresh: true
        }));
      }
    }

    // Use IntersectionObserver to lazy-init: buildAnim() only fires once,
    // the moment the section is within 300px of the viewport.
    // This works on every device without arbitrary timing delays.
    var built = false;
    var io = new IntersectionObserver(function (entries) {
      if (built || !entries[0].isIntersecting) return;
      built = true;
      io.disconnect();
      requestAnimationFrame(function () {
        buildAnim();
        ScrollTrigger.refresh();
      });
    }, { rootMargin: '300px 0px' });
    io.observe(section);

    var resizeTimer, lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => { buildAnim(); ScrollTrigger.refresh(); }, 250);
    });
  }

  /* --------------------------------------------------------
     Pill Cycle
  -------------------------------------------------------- */
  function initPillCycle() {
    const pillBlocks = [$('.pill-block1 .pill-bg'), $('.pill-block2 .pill-bg'), $('.pill-block3 .pill-bg')];
    const pillImgs = [$('.pill-img1'), $('.pill-img2'), $('.pill-img3')];
    let current = 0;
    function activate(i) {
      pillBlocks.forEach($el => $el.removeClass('wd-rounded-block'));
      pillImgs.forEach($el => $el.removeClass('active'));
      pillBlocks[i].addClass('wd-rounded-block');
      pillImgs[i].addClass('active');
    }
    activate(current);
    setInterval(() => { current = (current + 1) % pillBlocks.length; activate(current); }, 1500);
  }

  /* --------------------------------------------------------
     Customization Tabs
  -------------------------------------------------------- */
  function initCustomizationTabs() {
    const $tabs = $('.edit-canva-inner-tabs .customization-tab');
    const $imgs = $('.edit-canva-wrapper .guest-phone-inner');
    if (!$tabs.length || !$imgs.length) return;
    let clickedIndex = 0;
    function setActive(i) {
      $tabs.removeClass('active'); $imgs.removeClass('active');
      $tabs.eq(i).addClass('active'); $imgs.eq(i).addClass('active');
    }
    setActive(clickedIndex);
    $tabs.each(function (i) {
      $(this).on('click', function () { clickedIndex = i; setActive(i); });
      $(this).on('mouseenter', function () { setActive(i); });
    });
    $('.edit-canva-inner-tabs').on('mouseleave', () => setActive(clickedIndex));
  }

  /* --------------------------------------------------------
     Equalize Heights
  -------------------------------------------------------- */
  // function equalizeHeights() {
  //   $('.why-lum-single-content').css('height', 'auto');
  //   if ($(window).width() < 768) {
  //     var max = 0;
  //     $('.why-lum-single-content').each(function () { max = Math.max(max, $(this).outerHeight()); });
  //     $('.why-lum-single-content').css('height', max + 'px');
  //   }
  // }

  function equalizeHeights() {
    var $items = $('.why-lum-single-content');

    // RESET (write) first, but don't read yet
    $items.css('height', 'auto');

    if ($(window).width() >= 768) return; // nothing more to do on desktop

    // Force one single layout flush, then do all reads together
    requestAnimationFrame(function () {
      var max = 0;
      $items.each(function () {
        max = Math.max(max, this.offsetHeight); // batched reads, all after the single flush above
      });
      $items.css('height', max + 'px'); // batched write, after all reads are done
    });
  }
  equalizeHeights();
  $(window).on('resize', equalizeHeights);

  /* --------------------------------------------------------
     Footer Mouse Parallax
  -------------------------------------------------------- */
  const $bg = $('.footer-bg-radius');
  $(window).on('mousemove', function (e) {
    const x = (e.clientX / window.innerWidth - 0.5) * 250;
    const y = (e.clientY / window.innerHeight - 0.5) * 120;
    $bg.css('transform', `translate3d(${x}px, ${y}px, 0)`);
  });

  /* --------------------------------------------------------
     Chat Box Reveal
  -------------------------------------------------------- */
  function initChatBoxReveal(scope) {
    var $scope = $(scope || document);
    var $wrapper = $scope.find('.group-chat-wrapper');
    if (!$wrapper.length) return;

    // In theme editor — show all boxes immediately (no animation)
    if (window.Shopify && window.Shopify.designMode) {
      $wrapper.find('.single-chat-box').addClass('in-view');
      return;
    }

    // On storefront — staggered reveal via IntersectionObserver
    $wrapper.each(function () {
      var wrapperEl = this;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var stagger = window.innerWidth < 1024 ? 250 : 400;
            var $boxes = $(entry.target).find('.single-chat-box');
            $boxes.each(function (i) {
              var box = this;
              setTimeout(function () {
                $(box).addClass('in-view');
              }, i * stagger);
            });
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      observer.observe(wrapperEl);
    });
  }

  // Run on initial page load
  initChatBoxReveal(document);

  // Theme editor: re-init when this section is reloaded (block add/remove/reorder)
  document.addEventListener('shopify:section:load', function (event) {
    initChatBoxReveal(event.target);
  });

  // Theme editor: make the selected block visible immediately
  document.addEventListener('shopify:block:select', function (event) {
    var $block = $(event.target);
    if ($block.hasClass('single-chat-box') || $block.find('.single-chat-box').length) {
      $block.closest('.group-chat-wrapper').find('.single-chat-box').addClass('in-view');
    }
  });

  /* --------------------------------------------------------
     Global Resize — single, deduplicated ScrollTrigger refresh
  -------------------------------------------------------- */
  let globalResizeTimer;
  $(window).on("resize", function () {
    clearTimeout(globalResizeTimer);
    globalResizeTimer = setTimeout(() => {
      initLenis();
      ScrollTrigger.refresh();
      ScrollTrigger.sort();
    }, 500);
  });

  /* --------------------------------------------------------
     Instruction Tabs
  -------------------------------------------------------- */
  function initInstructionTabs() {

    $('.wd-tab-panel').hide();
    $('.wd-tab-panel:first').show();

    $('.wd-instructions-tabs .section-btn-two').click(function () {
      $('.wd-instructions-tabs .section-btn-two').removeClass('active');
      $(this).addClass('active');
      $('.wd-tab-panel').hide();

      var activeTab = $(this).find('button').attr('id'); // "tab2"
      $('#panel-' + activeTab).fadeIn(); // targets "#panel-tab2"
      return false;
    });

  }
  initInstructionTabs();

  // for all video
  // const videos = document.querySelectorAll("video");

  // const observer = new IntersectionObserver(entries => {
  //   entries.forEach(entry => {
  //     if (entry.isIntersecting) {
  //       const video = entry.target;
  //       video.play().catch(() => { });
  //     }
  //   });
  // });

  // videos.forEach(v => observer.observe(v));


})();